export const PROMPT_P04 = (sponsorProduct = 'Sikagard-703 W + Sika WT-200P') => `
Analyze for EFFLORESCENCE / WHITE STAINING (ACI 201.2R).
Visual indicators: white/gray calcium carbonate deposits, primary vs. secondary (recurring),
pattern: uniform (surface evaporation), channeled (crack leaching), stalactite-like (severe infiltration).
Return ONLY this JSON:
{
  "pathology_id": "p04_efflorescence",
  "pathology_name": { "es": "Eflorescencias", "en": "Efflorescence" },
  "norm": "ACI 201.2R",
  "confidence": 85,
  "requires_additional_input": false,
  "efflorescence_type": "primary|secondary|tertiary",
  "deposit_pattern": "uniform|channeled|stalactite|localized",
  "moisture_source_probable": "surface_evaporation|crack_infiltration|rising_damp|roof_leak|unknown",
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": ["1. Identificar y eliminar fuente de humedad (prioridad absoluta)","2. Limpieza mecánica en seco con cepillo duro","3. Si persiste: lavado HCl diluido 10% + neutralización + lavado abundante","4. Aplicar hidrofugante siloxánico penetrante + cristalizante en zonas activas"],
      "en": ["1. Identify and eliminate moisture source (absolute priority)","2. Dry mechanical cleaning with stiff brush","3. If persists: diluted 10% HCl wash + neutralization + thorough rinse","4. Apply penetrating siloxane water repellent + crystalline waterproofing in active zones"]
    },
    "norm_reference": "ACI 201.2R-16, Section 7.3"
  },
  "materials": {
    "generic": { "es": "Hidrofugante siloxánico penetrante; impermeabilizante cristalizante", "en": "Penetrating siloxane water repellent; crystalline waterproofing" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "Sikagard-703 W: protección ≥10 años en fachadas", "en": "Sikagard-703 W: ≥10-year protection on facades" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": { "es": "Eflorescencia es síntoma de humedad. Diagnóstico de fuente requiere inspección de impermeabilización.", "en": "Efflorescence is a moisture symptom. Source diagnosis requires full waterproofing inspection." }
}`;
